import React, {Component} from 'react';
import {connect} from 'react-redux';

import {queryAdjustmentInfo} from '@api/finance/budget';
import localDb from '@util/localDb';
import {getExpendType} from '@store/modules/finance/expend_type';
import {getCompanyList} from '@store/modules/company_list';

import PageAdd from './PageAdd';
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.getAdjustmentInfo();
    const { dispatch } = this.props;
    dispatch(getExpendType());
    dispatch(getCompanyList());
  }

  getAdjustmentInfo = () => {
    const { uuid } = this.props.params;
    queryAdjustmentInfo({
      uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageAdd params={this.props.params} {...this.props} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} {...this.props} />;
    }
    return <span />;
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(PageInfo);



// WEBPACK FOOTER //
// ./src/components/finance/budget/adjust/PageInfo.js